export const sections = [
  {
    id: 1,
    title: 'Bring Your Team Together',
    description: 'Answer questions about how your team actually operates',
    video: 'bring-team-together.mp4'
  },
  {
    id: 2,
    title: 'Build Your Results in Real Time',
    description: 'See your team’s profile emerge instantly across key practices',
    video: 'results-real-time.mp4'
  },
  {
    id: 3,
    title: 'Debate What Matters (Consensus Mode)',
    description: 'Align on answers—surfacing real dynamics and differences',
    video: 'debate-consensus.mp4'
  },
  {
    id: 4,
    title: 'Focus Your Development',
    description: 'Identify priorities and track progress over time',
    video: 'focus-development.mp4'
  }
]